<template>
  <div v-if="checkAccess() || !loading" class="fondo">
    <div class="columna">
      <div class="page-content">
        <div class="areaContainer">
          <TituloVistasComponent
            titulo="Pago Multas"
            imagen="https://d2b84d7va2oki2.cloudfront.net/icons/Group+258.svg"
          />
        </div>
        <div v-if="!loading" class="stateContainer">
          <div class="page-title">
            <p class="title">Resultado del pago de la multa</p>
          </div>
          <div class="resultBox">
            <div class="message">
              <div>
                <p
                  class="subtitle"
                  :style="{ color: isPaid ? '#39B54A' : '#D4145A' }"
                >
                  {{
                    !isPaid
                      ? `Ups!
                                    No hemos podido concretar tu pago`
                      : "Tu pago fue realizado con exito"
                  }}
                </p>
              </div>
              <div v-if="description">
                <p class="description">{{ description }}</p>
              </div>
              <div v-if="dbError">
                <p class="description" style="color: #d4145a">
                  Por favor reintentar registrar el pago varias veces, en caso
                  de persistir el problema acercarse al juzgado de faltas con el
                  comprobante de pago. NO volver a pagar.
                </p>
              </div>
            </div>
            <div class="containerButton">
              <div v-if="dbError && isPaid" class="failed">
                <div class="divButton">
                  <input
                    class="buttonAction retry"
                    type="button"
                    @click="saveInfractionPaid"
                    value="Reintentar Registro"
                    style="background-color: var(--color-brand-blue)"
                  />
                </div>
                <div class="divButton">
                  <BtnDownloadMultComponent
                    texto="DESCARGAR CONSTANCIA"
                    :body="body"
                  />
                </div>
              </div>
              <div v-if="!isPaid && retryable" class="divButton">
                <input
                  class="buttonAction"
                  type="button"
                  @click="reGeneratePayment"
                  value="Reintentar Pago"
                  style="background-color: var(--color-brand-blue)"
                />
              </div>
              <div v-if="!dbError && isPaid" class="divButton">
                <BtnDownloadMultComponent
                  texto="DESCARGAR CONSTANCIA"
                  :body="body"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="loading l">
          <div
            class="spinner-grow"
            role="status"
            style="background: var(--color-brand-blue)"
          >
            <span class="sr-only"></span>
          </div>
          <div
            class="spinner-grow"
            role="status"
            style="background: var(--color-brand-blue)"
          >
            <span class="sr-only"></span>
          </div>
          <div
            class="spinner-grow"
            role="status"
            style="background: var(--color-brand-blue)"
          >
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
      <div @click="cleanStore" class="flechas-container">
        <FlechasComponent tituloIzquierda="Inicio" :izquierda="`/mis-multas`" />
      </div>
    </div>
  </div>
</template>

<script setup>
import BtnDownloadMultComponent from "@/components/Buttons/BtnDownloadMultComponent.vue";
import FlechasComponent from "@/components/Flechas/FlechasComponent.vue";
import TituloVistasComponent from "@/components/Titulos/TituloVistasComponent.vue";
import PaymentHandlers from "@/services/handlers/paymentHandlers";
import Validator from "@/services/helpers/validator";
//import FileService from "@/services/infractions/filesService";
import StateTransitionService from "@/services/infractions/stateTransitionService";
//import FilesService from "@/services/office/filesService";
import PaymentSIROService from "@/services/office/paymentSIROService";
//import PDFDocument from "@/services/pdf/pdfDocument";
import store from "@/store/index";
import { onBeforeMount, ref, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const isPaid = ref(false);
const description = ref(null);
const loading = ref(false);
const dbError = ref(false);
const isRetry = ref(false);
const retryable = ref(true);
const body = ref({});

const cleanStore = () => {
  store.dispatch("clearBodyInfractionState");
};

const reGeneratePayment = async () => {
  if (isPaid.value) return;
  loading.value = true;
  isRetry.value = true;
  const infraction = {
    cost: store.state.changeStateStore.cost,
  };
  await PaymentHandlers.handleInfractionPaymentSIRO(infraction);
  description.value =
    "Error regenerando el pago. Por favor intentalo mas tarde. Te pedimos disculpas.";
  retryable.value = false;
  loading.value = false;
  isRetry.value = false;
};

const deleteFiles = async () => {
  loading.value = true;
  //const body = store.state.changeStateStore.body;
  //console.log("eliminar a ", body.filesCode);
  //aca llamar al futuro service para eliminar archivos por files code
  loading.value = false;
};

const saveInfractionPaid = async () => {
  isPaid.value = true;
  const body = store.state.changeStateStore.body;
  const response = await StateTransitionService.changeStateInfraction(body);
  if (response.success) {
    description.value = "Pago registrado con exito. Muchas gracias!";
    dbError.value = false;
    cleanStore();
  } else {
    description.value =
      "Hubo un error en registrar el pago en nuestra base de datos. Por favor descargar el comprobante y presentarlo en nuestras oficinas para su registro. NO repita el pago";
    dbError.value = true;
  }
};

const checkAccess = () => {
  return store.state.loggedIn;
};

const fetchPaymentState = async () => {
  loading.value = true;

  //const constancia = await PDFDocument.NotificationPDF()

  const IdResultado = route.query.IdResultado; // Correcto
  const IdReferenciaOperacion = route.query.IdReferenciaOperacion;
  const infractionId = store.state.changeStateStore.body.infractionId;
  body.value = {
    infractionId,
    IdReferenciaOperacion,
    IdResultado,
  };
  try {
    const response = await PaymentSIROService.getPaymentState(
      IdResultado,
      IdReferenciaOperacion,
    );
    if (response.success) {
      await saveInfractionPaid();
    } else {
      isPaid.value = false;
      description.value = response.message;
    }
  } catch (error) {
    console.error(error);
  }

  loading.value = false;
};

onBeforeMount(async () => {
  if (!checkAccess()) {
    router.push({ name: "login" });
    return;
  }

  if (!store.state.changeStateStore) {
    if (store.state.user.muniAreas) Validator.pushTo();
    router.push({ name: "munienlinea" });
  }
  fetchPaymentState();
});

onBeforeUnmount(async () => {
  if (!isRetry.value) {
    if (dbError.value) await deleteFiles();
    //cleanStore();
    // console.log("desmonta")
  }
});
</script>

<style scoped>
.areaContainer > .general {
  margin-left: 0px !important;
}

.flechas-container > .volver {
  margin-bottom: 0px !important;
  margin-left: 0px !important;
}

.buttonAction {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  color: var(--bg-popup);
  font-family: Nunito;
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  line-height: 90%;
  /* 13.5px */
  letter-spacing: -0.3px;
  border: none;
  width: 50%;
  padding: 12px 15px;
}

.containerButton {
  display: flex;
  justify-content: center;
  bottom: 0%;
  width: 100%;
}

.divButton {
  display: flex;
  width: 30%;
  justify-content: center;
}

.retry {
  font-size: 20px;
  font-weight: 800;
  border-radius: 12px;
}

.failed {
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: center;
}

.message {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 20px;
  align-items: flex-start;
}

.resultBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  justify-content: space-between;
  width: 80%;
  border-radius: 20px;
  border-radius: 20px;
  border: 1px solid #ababab;
  background: rgba(255, 255, 255, 0.75);
  padding: 20px 30px;
  margin-top: 40px;
  gap: 16px;
}

.stateContainer {
  height: 100%;
  flex-grow: 1;
  justify-content: space-between;
}

.title {
  font-family: Nunito;
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  line-height: 90%;
  /* 13.5px */
  letter-spacing: -0.3px;
}

.subtitle {
  text-align: center;
  font-family: Nunito;
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  line-height: 90%;
  letter-spacing: -0.3px;
}

.description {
  color: #4d4d4d;
  font-family: Nunito;
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  line-height: 90%;
  letter-spacing: -0.3px;
}

.fondo {
  background-color: transparent;
  width: 100%;
  min-height: 100vh;
  padding-top: 70px;
  padding-left: 252px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.columna {
  height: 100%;
  /* Asegúrate de que el contenedor tenga una altura definida */
  width: 100%;
  display: flex;
  /* Habilita flexbox para los hijos */
  flex-direction: column;
  /* Alinea los hijos verticalmente */
  justify-content: space-between;
  /* Distribuye el espacio entre los hijos */
}

.page-content {
}

.loading {
  width: 25%;
  margin: auto;
  gap: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1360px) {
  .fondo {
    width: 800%;
    min-height: 100vh;
    padding-top: 108px;
    padding-bottom: 104px;
    padding-left: 200px;
  }
}

@media (max-width: 900px) {
  .fondo {
    width: 100%;
    min-height: 100vh;
    padding-top: 108px;
    padding-bottom: 104px;
    padding-left: 0px;
  }
}

@media (max-width: 700px) {
  .fondo {
    width: 100%;
    min-height: 100vh;
    padding-top: 108px;
    padding-bottom: 0px;
    padding-left: 0px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }

  .columna {
    width: 80%;
    min-height: 100%;
    height: 85vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .resultBox {
    width: 100%;
    align-items: center;
  }

  .message {
    align-items: center;
  }

  .divButton {
    width: 70%;
  }

  .retry {
    font-size: 15px;
    font-weight: 900;
  }

  .buttonAction.retry {
    white-space: normal;
    padding: 0px 15px 0px;
  }
}
</style>
